import { useCallback, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useUserPrint } from '@app/hooks';
import { getAccessToken } from '@app/utils';

export const useBooking = () => {
  const [isLoading, setIsLoading] = useState(true);
  const { activeBranchId } = useUserPrint();
  const navigate = useNavigate();

  const accessToken = getAccessToken() ?? '';

  const bookingHost = process.env.REACT_APP_BOOKING_HOST || '';
  const bookingOrigin = useMemo(() => {
    try {
      return new URL(bookingHost).origin;
    } catch {
      return '*';
    }
  }, [bookingHost]);

  const [iframeUrl] = useState<string>(() => {
    try {
      const url = new URL(bookingHost);
      if (accessToken) url.searchParams.set('jwt', accessToken);
      if (activeBranchId != null)
        url.searchParams.set('branchId', String(activeBranchId));
      url.searchParams.set('redirect', window.location.pathname);
      return url.toString();
    } catch {
      return '';
    }
  });

  const handleChildNavigation = useCallback(
    (event: MessageEvent) => {
      if (event.origin !== bookingOrigin && bookingOrigin !== '*') return;
      if (event.data?.type === 'ROUTE_CHANGE') {
        const {
          path = '',
          search = '',
          hash = '',
        } = event.data as {
          path?: string;
          search?: string;
          hash?: string;
        };
        navigate(`${path}${search}${hash}`, { replace: true });
      }
    },
    [navigate, bookingOrigin]
  );

  return {
    handleChildNavigation,
    iframeUrl,
    accessToken,
    setIsLoading,
    isLoading,
    bookingOrigin,
  };
};
